import React from 'react';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop, PanelBody } from 'components/Panel';

const LoginPage = ({ error }) => (
    <Main>
        <MainHeader />
        <Body id="login-page">
            <Panel border nopad>
                <PanelTop title="Member Login" />
                <form action="/login" method="post">
                    <PanelBody textCenter>
                        <div className="cc-text-error">{error}</div>
                        <input className="cc-input" type="text" name="username" placeholder="Username" />
                        <input className="cc-input" type="password" name="password" placeholder="Password" />
                        <div id="login-remember-me">
                            <input type="checkbox" name="persistent_login" />
                            <span>Remember me</span>
                        </div>
                        <input className="cc-flat-button" type="submit" value="Login" />
                    </PanelBody>
                </form>
                <PanelBody>
                    <a className="cc-left" href="/register">
                        Register
                    </a>
                    <a className="cc-right" href="/forgot-password">
                        Forgot password?
                    </a>
                    <div className="cc-clear" />
                </PanelBody>
            </Panel>
        </Body>
    </Main>
);

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/login/LoginPage.jsx